import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import React from 'react';
import styled from 'styled-components/native';
import FlagIcon from '@/assets/icon/ic_flag_colored.svg';
import PencilIcon from '@/assets/icon/ic_pencil_colored.svg';
import WheelchairIcon from '@/assets/icon/ic_wheelchair_colored.svg';
import { SccPressable } from '@/components/SccPressable';
import { color } from '@/constant/color';
import { font } from '@/constant/font';
import BottomSheet from '@/modals/BottomSheet';
export default function PlaceDetailRegistrationSheet({ isVisible, onClose, onPressPlaceRegister, onPressBuildingRegister, onPressReviewRegister, onPressToiletRegister, isAccessibilityRegistrable, }) {
    return (_jsx(BottomSheet, { isVisible: isVisible, onPressBackground: onClose, children: _jsxs(Container, { children: [_jsxs(MenuItem, { elementName: "place_detail_registration_sheet_place", onPress: () => {
                        onClose();
                        onPressPlaceRegister();
                    }, disabled: !isAccessibilityRegistrable, children: [_jsx(FlagIcon, { width: 16, height: 16 }), _jsx(MenuItemText, { children: "\uB9E4\uC7A5 \uC811\uADFC\uC131 \uB4F1\uB85D\uD558\uAE30" })] }), _jsx(Divider, {}), _jsxs(MenuItem, { elementName: "place_detail_registration_sheet_building", onPress: () => {
                        onClose();
                        onPressBuildingRegister();
                    }, disabled: !isAccessibilityRegistrable, children: [_jsx(FlagIcon, { width: 16, height: 16 }), _jsx(MenuItemText, { children: "\uAC74\uBB3C \uC811\uADFC\uC131 \uB4F1\uB85D\uD558\uAE30" })] }), _jsx(Divider, {}), _jsxs(MenuItem, { elementName: "place_detail_registration_sheet_review", onPress: () => {
                        onClose();
                        onPressReviewRegister();
                    }, disabled: !isAccessibilityRegistrable, children: [_jsx(PencilIcon, { width: 16, height: 16 }), _jsx(MenuItemText, { children: "\uB0B4\uBD80 \uB9AC\uBDF0 \uB4F1\uB85D\uD558\uAE30" })] }), _jsx(Divider, {}), _jsxs(MenuItem, { elementName: "place_detail_registration_sheet_toilet", onPress: () => {
                        onClose();
                        onPressToiletRegister();
                    }, disabled: !isAccessibilityRegistrable, children: [_jsx(WheelchairIcon, { width: 16, height: 16 }), _jsx(MenuItemText, { children: "\uD654\uC7A5\uC2E4 \uC815\uBCF4 \uB4F1\uB85D\uD558\uAE30" })] })] }) }));
}
const Container = styled.View `
  background-color: ${color.white};
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  padding-top: 12px;
`;
const MenuItem = styled(SccPressable) `
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 60px;
  padding: 0 20px;
  gap: 10px;
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
`;
const MenuItemText = styled.Text `
  font-family: ${font.pretendardMedium};
  font-size: 15px;
  line-height: 22px;
  letter-spacing: -0.3px;
  color: ${color.black};
`;
const Divider = styled.View `
  height: 1px;
  background-color: ${color.gray15};
`;
